import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';

export const printApi = {
  printPrescription: async (id: number): Promise<{ message: string; paperWidthMM?: number; paperHeightMM?: number }> => {
    const response = await apiClient.post<{ message: string; paperWidthMM?: number; paperHeightMM?: number }>(
      API_ENDPOINTS.PRINT_PRESCRIPTION(id)
    );
    return response.data;
  },

  downloadPrescriptionPdf: async (id: number): Promise<void> => {
    const response = await apiClient.get(API_ENDPOINTS.DOWNLOAD_PRESCRIPTION_PDF(id), {
      responseType: 'blob',
    });
    
    // Create blob URL and trigger download
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    // Extract filename from Content-Disposition header or use default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `prescription_${id}.pdf`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }
    
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  downloadPrescriptionPdfByUrl: async (downloadUrl: string): Promise<boolean> => {
    try {
      const response = await apiClient.get(downloadUrl, {
        responseType: 'blob',
      });
      
      // Create blob URL and trigger download
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Extract filename from Content-Disposition header or use default
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'prescription.pdf';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } catch (error) {
      console.error('Error downloading PDF by URL:', error);
      return false;
    }
  },

  getAvailablePrinters: async (): Promise<string[]> => {
    const response = await apiClient.get<string[]>(API_ENDPOINTS.AVAILABLE_PRINTERS);
    return response.data;
  },

  /** Fetch PDF as blob for preview (with auth). Caller must revoke the returned object URL when done. */
  getPrescriptionPdfForPreview: async (id: number): Promise<string> => {
    const response = await apiClient.get<Blob>(API_ENDPOINTS.DOWNLOAD_PRESCRIPTION_PDF(id), {
      responseType: 'blob',
    });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return window.URL.createObjectURL(blob);
  },
};

